module.exports = __webpack_public_path__ + "img/sec4_3_.0d6b9b92.png";